import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {AddDashboardConfiguration} from "../models/AddDashboardConfiguration";
import {AddDashboardDialog} from "../component/AddDashboardDialogComponent";

export class AddDashboardService {

    public static readonly id = "addDashboardService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {
    }

    public async open(): Promise<AddDashboardConfiguration> {
        const options: IModalSettings = {
            backdrop: "static",
            component: AddDashboardDialog
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}
